import noop from 'lodash/noop';
import React from 'react';
import { DrawerContextValue } from '@repo/ui/src/modules/UI';

export const DrawerContext = React.createContext<DrawerContextValue>({
  inDrawer: false,
  close: noop,
  closeAll: noop,
  index: 0,
  id: null,
});
